export default __webpack_public_path__ + "static/media/datte.796384de.webp";